{
  "Attachments": true,
  "XP": {
    "xp": {
      "docsId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
      "totalXp": 37000,
      "currentLevel": 7,
      "currentLevelLow": 32300,
      "currentLevelHigh": 48499,
      "currentLevelPointsEarned": 4700,
      "nextLevel": 8,
      "pointsUntilNextLevel": 11500,
      "achievementCategories": {
        "Unknown": 0,
        "Modules": 31,
        "Courses": 1,
        "Qna": 0,
        "Challenges": 0,
        "Events": 0,
        "LearningPaths": 3,
        "Plans": 0,
        "Special": 0
      }
    },
    "achievements": [
      {
        "category": "learningpaths",
        "typeId": "learn.wwl.develop-ai-solutions-azure-openai.trophy",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "QD2UVUPE",
        "title": "Develop Generative AI solutions with Azure OpenAI Service",
        "imageUrl": "/training/achievements/develop-ai-solutions-azure-openai.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:49.315Z",
        "url": "/training/paths/develop-ai-solutions-azure-openai/",
        "milestoneEligible": true,
        "version": 3948
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.responsible-generative-ai.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "24R5XQPV",
        "title": "Fundamentals of Responsible Generative AI",
        "imageUrl": "/learn/achievements/generic-badge.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:49.315Z",
        "url": "/training/modules/responsible-generative-ai/",
        "milestoneEligible": true,
        "version": 7732
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.use-own-data-azure-openai.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "DGP8QS5J",
        "title": "Implement Retrieval Augmented Generation (RAG) with Azure OpenAI Service",
        "imageUrl": "/learn/achievements/generic-badge.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:49.049Z",
        "url": "/training/modules/use-own-data-azure-openai/",
        "milestoneEligible": true,
        "version": 8226
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.generate-images-azure-openai.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "K5Q3VJJB",
        "title": "Generate images with Azure OpenAI Service",
        "imageUrl": "/learn/achievements/generic-badge.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:48.815Z",
        "url": "/training/modules/generate-images-azure-openai/",
        "milestoneEligible": true,
        "version": 2341
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.generate-code-azure-openai.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "VKALYEQM",
        "title": "Generate code with Azure OpenAI Service",
        "imageUrl": "/learn/achievements/generic-badge.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:48.565Z",
        "url": "/training/modules/generate-code-azure-openai/",
        "milestoneEligible": true,
        "version": 3888
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.apply-prompt-engineering-azure-openai.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "WAUECFWN",
        "title": "Apply prompt engineering with Azure OpenAI Service",
        "imageUrl": "/learn/achievements/generic-badge.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:48.33Z",
        "url": "/training/modules/apply-prompt-engineering-azure-openai/",
        "milestoneEligible": true,
        "version": 4570
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.build-language-solution-azure-openai.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "N73P9XWF",
        "title": "Build natural language solutions with Azure OpenAI Service",
        "imageUrl": "/learn/achievements/generic-badge.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:48.065Z",
        "url": "/training/modules/build-language-solution-azure-openai/",
        "milestoneEligible": true,
        "version": 3026
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.get-started-openai.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "8R9Q6N3W",
        "title": "Get started with Azure OpenAI Service",
        "imageUrl": "/learn/achievements/generic-badge.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:47.83Z",
        "url": "/training/modules/get-started-openai/",
        "milestoneEligible": true,
        "version": 3769
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.work-with-form-recognizer.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "ZPYSFVR2",
        "title": "Extract data from forms with Azure Document Intelligence",
        "imageUrl": "/training/achievements/form-recognizer-extract-data.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:47.565Z",
        "url": "/training/modules/work-form-recognizer/",
        "milestoneEligible": true,
        "version": 3574
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.use-prebuilt-form-recognizer-models.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "EJ2C742P",
        "title": "Use prebuilt Form Recognizer models",
        "imageUrl": "/training/achievements/use-prebuilt-form-recognizer-models.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:47.33Z",
        "url": "/training/modules/use-prebuilt-form-recognizer-models/",
        "milestoneEligible": true,
        "version": 8164
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.plan-form-recognizer-solution.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "9NLZS3TU",
        "title": "Plan an Azure AI Document Intelligence solution",
        "imageUrl": "/training/achievements/plan-form-recognizer-solution.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:47.065Z",
        "url": "/training/modules/plan-form-recognizer-solution/",
        "milestoneEligible": true,
        "version": 2867
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.create-knowledge-store-with-azure-cognitive-search.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "8R9Q6NLW",
        "title": "Create a knowledge store with Azure AI Search",
        "imageUrl": "/training/achievements/implementing-a-knowledge-store.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:46.83Z",
        "url": "/training/modules/create-knowledge-store-azure-cognitive-search/",
        "milestoneEligible": true,
        "version": 7936
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.create-enrichment-pipeline-with-azure-cognitive-search.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "QDZ6APFE",
        "title": "Create a custom skill for Azure AI Search",
        "imageUrl": "/training/achievements/create-an-enrichment-pipeline.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:46.58Z",
        "url": "/training/modules/create-enrichment-pipeline-azure-cognitive-search/",
        "milestoneEligible": true,
        "version": 7937
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.create-azure-cognitive-search-solution.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "3X6VL8BH",
        "title": "Create an Azure AI Search solution",
        "imageUrl": "/training/achievements/create-an-azure-cognitive-search-solution.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:46.33Z",
        "url": "/training/modules/create-azure-cognitive-search-solution/",
        "milestoneEligible": true,
        "version": 7935
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.translate-speech-speech-service.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "PTV9ZKW4",
        "title": "Translate speech with the Azure AI Speech service",
        "imageUrl": "/training/achievements/translate-speech-speech-service.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:46.049Z",
        "url": "/training/modules/translate-speech-speech-service/",
        "milestoneEligible": true,
        "version": 2445
      },
      {
        "category": "learningpaths",
        "typeId": "learn.wwl.develop-language-solutions-azure-ai.trophy",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "UF6QCMU3",
        "title": "Develop natural language processing solutions with Azure AI Services",
        "imageUrl": "/training/achievements/create-language-solution-azure-cognitive-services.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:46.049Z",
        "url": "/training/paths/develop-language-solutions-azure-ai/",
        "milestoneEligible": true,
        "version": 3586
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.create-speech-enabled-apps.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "9NLZS3MU",
        "title": "Create speech-enabled apps with Azure AI services",
        "imageUrl": "/training/achievements/transcribe-speech-input-text.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:45.783Z",
        "url": "/training/modules/create-speech-enabled-apps/",
        "milestoneEligible": true,
        "version": 2800
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.translate-text-with-translator-service.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "FZH4UYBX",
        "title": "Translate text with Azure AI Translator service",
        "imageUrl": "/training/achievements/translate-text-with-the-translator-service.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:45.533Z",
        "url": "/training/modules/translate-text-with-translator-service/",
        "milestoneEligible": true,
        "version": 7890
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.custom-name-entity-recognition.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "3X6VL8VH",
        "title": "Custom named entity recognition",
        "imageUrl": "/training/achievements/2-custom-name-entity-recognition.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:45.299Z",
        "url": "/training/modules/custom-name-entity-recognition/",
        "milestoneEligible": true,
        "version": 2535
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.custom-text-classification.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "CW57TUA9",
        "title": "Create a custom text classification solution",
        "imageUrl": "/training/achievements/1-create-custom-text-classification-solutions.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:45.049Z",
        "url": "/training/modules/custom-text-classification/",
        "milestoneEligible": true,
        "version": 3600
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.build-language-understanding-model.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "HYCMGWZ8",
        "title": "Build a conversational language understanding model",
        "imageUrl": "/training/achievements/build-language-understanding-model.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:44.768Z",
        "url": "/training/modules/build-language-understanding-model/",
        "milestoneEligible": true,
        "version": 3086
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.create-question-answer-solution-ai-language.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "X28K3RMY",
        "title": "Build a question answering solution",
        "imageUrl": "/training/achievements/qna-maker-solution.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:44.518Z",
        "url": "/training/modules/create-question-answer-solution-ai-language/",
        "milestoneEligible": true,
        "version": 2633
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.analyze-text-ai-language.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "4SMU2B5K",
        "title": "Analyze text with Azure AI Language",
        "imageUrl": "/training/achievements/extract-insights-from-text-with-the-text-analytics-service.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:44.221Z",
        "url": "/training/modules/analyze-text-ai-language/",
        "milestoneEligible": true,
        "version": 3923
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.analyze-video.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "YVWBHAVR",
        "title": "Analyze video",
        "imageUrl": "/training/achievements/azure-video-indexer-analyze-video.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:43.924Z",
        "url": "/training/modules/analyze-video/",
        "milestoneEligible": true,
        "version": 4504
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.read-text-images-documents-with-computer-vision-service.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "WAUECFRN",
        "title": "Read Text in images and documents with the Azure AI Vision Service",
        "imageUrl": "/training/achievements/read-text-images-documents-with-computer-vision-service.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:43.69Z",
        "url": "/training/modules/read-text-images-documents-with-computer-vision-service/",
        "milestoneEligible": true,
        "version": 7959
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.detect-analyze-recognize-faces.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "24R5XMEV",
        "title": "Detect, analyze, and recognize faces",
        "imageUrl": "/training/achievements/artificial-intelligence-detect-faces.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:43.44Z",
        "url": "/training/modules/detect-analyze-recognize-faces/",
        "milestoneEligible": true,
        "version": 4255
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.classify-images.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "DGP8QTSJ",
        "title": "Classify images",
        "imageUrl": "/training/achievements/images-classify.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:43.19Z",
        "url": "/training/modules/classify-images/",
        "milestoneEligible": true,
        "version": 4614
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.analyze-images.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "VKALXVVM",
        "title": "Analyze images",
        "imageUrl": "/training/achievements/computer-vision-analyze-images.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:42.846Z",
        "url": "/training/modules/analyze-images/",
        "milestoneEligible": true,
        "version": 2574
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.investigate-container-for-use-with-ai-services.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "N73PCN8F",
        "title": "Deploy Azure AI services in containers",
        "imageUrl": "/training/achievements/investigate-container-for-use-with-cognitive-services.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:42.611Z",
        "url": "/training/modules/investigate-container-for-use-with-ai-services/",
        "milestoneEligible": true,
        "version": 4620
      },
      {
        "category": "learningpaths",
        "typeId": "learn.wwl.get-started-azure-ai.trophy",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "3XCE9QUH",
        "title": "Get started with Azure AI Services",
        "imageUrl": "/training/achievements/provision-and-manage-azure-cognitive-services.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:42.611Z",
        "url": "/training/paths/get-started-azure-ai/",
        "milestoneEligible": true,
        "version": 7676
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.monitor-ai-services.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "ZPYSNZY2",
        "title": "Monitor Azure AI services",
        "imageUrl": "/learn/achievements/monitor-cognitive-services.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:42.346Z",
        "url": "/training/modules/monitor-ai-services/",
        "milestoneEligible": true,
        "version": 7632
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.secure-ai-services.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "EJ2CAEZP",
        "title": "Secure Azure AI services",
        "imageUrl": "/training/achievements/secure-cognitive-services.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:42.111Z",
        "url": "/training/modules/secure-ai-services/",
        "milestoneEligible": true,
        "version": 7633
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.create-manage-ai-services.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "HYCMLHG8",
        "title": "Create and consume Azure AI services",
        "imageUrl": "/training/achievements/create-and-manage-cognitive-services.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:41.861Z",
        "url": "/training/modules/create-manage-ai-services/",
        "milestoneEligible": true,
        "version": 7631
      },
      {
        "category": "modules",
        "typeId": "learn.wwl.prepare-to-develop-ai-solutions-azure.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "BLEHVBVD",
        "title": "Prepare to develop AI solutions on Azure",
        "imageUrl": "/training/achievements/azure-develop-ai-solutions.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:41.58Z",
        "url": "/training/modules/prepare-to-develop-ai-solutions-azure/",
        "milestoneEligible": true,
        "version": 2755
      },
      {
        "category": "courses",
        "typeId": "course.ai-102t00.badge",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "id": "QDZ6RQNE",
        "title": "Designing and Implementing a Microsoft Azure AI Solution",
        "imageUrl": "/media/learn/certification/course.svg",
        "locale": "en-us",
        "verified": false,
        "source": "Progress",
        "grantedOn": "2024-02-28T23:12:39.643Z",
        "url": "/training/courses/ai-102t00/",
        "milestoneEligible": true,
        "version": 946
      }
    ]
  },
  "Progress": {
    "completedLearningItems": [
      {
        "title": "learn.wwl.prepare-to-develop-ai-solutions-azure.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.3367736Z"
      },
      {
        "title": "learn.wwl.prepare-to-develop-ai-solutions-azure.define-artificial-intelligence",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.3367764Z"
      },
      {
        "title": "learn.wwl.prepare-to-develop-ai-solutions-azure.understand-ai-related-terms",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.3367773Z"
      },
      {
        "title": "learn.wwl.prepare-to-develop-ai-solutions-azure.understand-considerations-for-ai-engineers",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.3367781Z"
      },
      {
        "title": "learn.wwl.prepare-to-develop-ai-solutions-azure.understand-considerations-for-responsible-ai",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.3367791Z"
      },
      {
        "title": "learn.wwl.prepare-to-develop-ai-solutions-azure.understand-capabilities-of-azure-machine-learning",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.3367804Z"
      },
      {
        "title": "learn.wwl.prepare-to-develop-ai-solutions-azure.understand-capabilities-of-azure-cognitive-services",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.3367812Z"
      },
      {
        "title": "learn.wwl.prepare-to-develop-ai-solutions-azure.understand-capabilities-of-azure-openai-service",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.3367823Z"
      },
      {
        "title": "learn.wwl.prepare-to-develop-ai-solutions-azure.understand-capabilities-of-azure-cognitive-search",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.3367834Z"
      },
      {
        "title": "learn.wwl.prepare-to-develop-ai-solutions-azure.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.3367844Z"
      },
      {
        "title": "learn.wwl.prepare-to-develop-ai-solutions-azure.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.3367854Z"
      },
      {
        "title": "learn.wwl.prepare-to-develop-ai-solutions-azure",
        "type": "module",
        "completedAt": "2024-02-28T23:12:41.3367857Z"
      },
      {
        "title": "learn.wwl.create-manage-ai-services.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.5976311Z"
      },
      {
        "title": "learn.wwl.create-manage-ai-services.create-resource",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.5976333Z"
      },
      {
        "title": "learn.wwl.create-manage-ai-services.identify-keys-endpoints",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.5976344Z"
      },
      {
        "title": "learn.wwl.create-manage-ai-services.use-rest",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.5976353Z"
      },
      {
        "title": "learn.wwl.create-manage-ai-services.use-sdk",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.5976363Z"
      },
      {
        "title": "learn.wwl.create-manage-ai-services.exercise-ai-services",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.5976372Z"
      },
      {
        "title": "learn.wwl.create-manage-ai-services.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.5976384Z"
      },
      {
        "title": "learn.wwl.create-manage-ai-services.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.5976394Z"
      },
      {
        "title": "learn.wwl.create-manage-ai-services",
        "type": "module",
        "completedAt": "2024-02-28T23:12:41.5976397Z"
      },
      {
        "title": "learn.wwl.secure-ai-services.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.8738583Z"
      },
      {
        "title": "learn.wwl.secure-ai-services.keys-with-azure-key-vault",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.8738607Z"
      },
      {
        "title": "learn.wwl.secure-ai-services.implement-network-security",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.8738616Z"
      },
      {
        "title": "learn.wwl.secure-ai-services.exercise-secure-ai-services",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.8738625Z"
      },
      {
        "title": "learn.wwl.secure-ai-services.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.8738636Z"
      },
      {
        "title": "learn.wwl.secure-ai-services.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:41.8738646Z"
      },
      {
        "title": "learn.wwl.secure-ai-services",
        "type": "module",
        "completedAt": "2024-02-28T23:12:41.8738649Z"
      },
      {
        "title": "learn.monitor-ai-services.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.1210012Z"
      },
      {
        "title": "learn.monitor-ai-services.monitor-cost",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.1210042Z"
      },
      {
        "title": "learn.monitor-ai-services.create-alerts",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.1210052Z"
      },
      {
        "title": "learn.monitor-ai-services.view-metrics",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.1210065Z"
      },
      {
        "title": "learn.monitor-ai-services.diagnostic-logging",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.1210076Z"
      },
      {
        "title": "learn.monitor-ai-services.exercise-monitor",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.1210087Z"
      },
      {
        "title": "learn.monitor-ai-services.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.1210096Z"
      },
      {
        "title": "learn.monitor-ai-services.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.1210109Z"
      },
      {
        "title": "learn.wwl.monitor-ai-services",
        "type": "module",
        "completedAt": "2024-02-28T23:12:42.1210113Z"
      },
      {
        "title": "learn.wwl.investigate-container-for-use-with-ai-services.introduction-to-containerization-of",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.3580134Z"
      },
      {
        "title": "learn.wwl.investigate-container-for-use-with-ai-services.understand-containers",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.358016Z"
      },
      {
        "title": "learn.wwl.investigate-container-for-use-with-ai-services.use-ai-services-containers",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.3580169Z"
      },
      {
        "title": "learn.wwl.investigate-container-for-use-with-ai-services.exercise-use-container",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.3580181Z"
      },
      {
        "title": "learn.wwl.investigate-container-for-use-with-ai-services.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.3580192Z"
      },
      {
        "title": "learn.wwl.investigate-container-for-use-with-ai-services.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.3580206Z"
      },
      {
        "title": "learn.wwl.investigate-container-for-use-with-ai-services",
        "type": "module",
        "completedAt": "2024-02-28T23:12:42.3580209Z"
      },
      {
        "title": "learn.wwl.analyze-images.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.6344663Z"
      },
      {
        "title": "learn.wwl.analyze-images.provision-computer-vision-resource",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.634469Z"
      },
      {
        "title": "learn.wwl.analyze-images.analyze-image",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.6344698Z"
      },
      {
        "title": "learn.wwl.analyze-images.generate-smart-cropped-thumbnail",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.6344711Z"
      },
      {
        "title": "learn.wwl.analyze-images.exercise-computer-vision",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.634472Z"
      },
      {
        "title": "learn.wwl.analyze-images.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.6344731Z"
      },
      {
        "title": "learn.wwl.analyze-images.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.634474Z"
      },
      {
        "title": "learn.wwl.analyze-images",
        "type": "module",
        "completedAt": "2024-02-28T23:12:42.6344742Z"
      },
      {
        "title": "learn.wwl.classify-images.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.8706729Z"
      },
      {
        "title": "learn.wwl.classify-images.provision-azure-resources-for-custom-vision",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.8706751Z"
      },
      {
        "title": "learn.wwl.classify-images.understand-image-classification",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.8706758Z"
      },
      {
        "title": "learn.wwl.classify-images.train-image-classifier",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.8706771Z"
      },
      {
        "title": "learn.wwl.classify-images.exercise-custom-vision",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.8706783Z"
      },
      {
        "title": "learn.wwl.classify-images.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.8706793Z"
      },
      {
        "title": "learn.wwl.classify-images.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:42.8706804Z"
      },
      {
        "title": "learn.wwl.classify-images",
        "type": "module",
        "completedAt": "2024-02-28T23:12:42.8706806Z"
      },
      {
        "title": "learn.wwl.detect-analyze-recognize-faces.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.2121725Z"
      },
      {
        "title": "learn.wwl.detect-analyze-recognize-faces.identify-options-for-face-detection-analysis-identification",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.2121755Z"
      },
      {
        "title": "learn.wwl.detect-analyze-recognize-faces.understand-considerations-for-face-analysis",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.2121765Z"
      },
      {
        "title": "learn.wwl.detect-analyze-recognize-faces.detect-faces-computer-vision-service",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.2121778Z"
      },
      {
        "title": "learn.wwl.detect-analyze-recognize-faces.understand-capabilities-of-face-service",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.2121795Z"
      },
      {
        "title": "learn.wwl.detect-analyze-recognize-faces.compare-match-detected-faces",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.2121809Z"
      },
      {
        "title": "learn.wwl.detect-analyze-recognize-faces.implement-facial-recognition",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.2121831Z"
      },
      {
        "title": "learn.wwl.detect-analyze-recognize-faces.exercise-identify-faces",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.2121843Z"
      },
      {
        "title": "learn.wwl.detect-analyze-recognize-faces.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.2121857Z"
      },
      {
        "title": "learn.wwl.detect-analyze-recognize-faces.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.212187Z"
      },
      {
        "title": "learn.wwl.detect-analyze-recognize-faces",
        "type": "module",
        "completedAt": "2024-02-28T23:12:43.2121873Z"
      },
      {
        "title": "learn.wwl.read-text-images-documents-with-computer-vision-service.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.4527119Z"
      },
      {
        "title": "learn.wwl.read-text-images-documents-with-computer-vision-service.options-for-reading-text",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.4527143Z"
      },
      {
        "title": "learn.wwl.read-text-images-documents-with-computer-vision-service.using-read-api",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.4527153Z"
      },
      {
        "title": "learn.wwl.read-text-images-documents-with-computer-vision-service.exercise",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.4527161Z"
      },
      {
        "title": "learn.wwl.read-text-images-documents-with-computer-vision-service.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.4527171Z"
      },
      {
        "title": "learn.wwl.read-text-images-documents-with-computer-vision-service.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.4527181Z"
      },
      {
        "title": "learn.wwl.read-text-images-documents-with-computer-vision-service",
        "type": "module",
        "completedAt": "2024-02-28T23:12:43.4527183Z"
      },
      {
        "title": "learn.wwl.analyze-video.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.7029746Z"
      },
      {
        "title": "learn.wwl.analyze-video.understand-video-indexer-capabilities",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.7029766Z"
      },
      {
        "title": "learn.wwl.analyze-video.extract-custom-insights",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.7029775Z"
      },
      {
        "title": "learn.wwl.analyze-video.use-video-indexer-widgets-apis",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.7029784Z"
      },
      {
        "title": "learn.wwl.analyze-video.exercise-video-indexer",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.7029793Z"
      },
      {
        "title": "learn.wwl.analyze-video.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.7029803Z"
      },
      {
        "title": "learn.wwl.analyze-video.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.7029812Z"
      },
      {
        "title": "learn.wwl.analyze-video",
        "type": "module",
        "completedAt": "2024-02-28T23:12:43.7029814Z"
      },
      {
        "title": "learn.wwl.analyze-text-ai-language.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.9443339Z"
      },
      {
        "title": "learn.wwl.analyze-text-ai-language.provision-resource",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.9443362Z"
      },
      {
        "title": "learn.wwl.analyze-text-ai-language.detect-language",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.9443371Z"
      },
      {
        "title": "learn.wwl.analyze-text-ai-language.extract-key-phrases",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.9443379Z"
      },
      {
        "title": "learn.wwl.analyze-text-ai-language.analyze-sentiment",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.9443391Z"
      },
      {
        "title": "learn.wwl.analyze-text-ai-language.extract-entitites",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.9443403Z"
      },
      {
        "title": "learn.wwl.analyze-text-ai-language.extract-linked-entitites",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.9443412Z"
      },
      {
        "title": "learn.wwl.analyze-text-ai-language.exercise",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.9443422Z"
      },
      {
        "title": "learn.wwl.analyze-text-ai-language.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.9443447Z"
      },
      {
        "title": "learn.wwl.analyze-text-ai-language.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:43.9443459Z"
      },
      {
        "title": "learn.wwl.analyze-text-ai-language",
        "type": "module",
        "completedAt": "2024-02-28T23:12:43.9443462Z"
      },
      {
        "title": "learn.wwl.create-question-answer-solution-ai-language.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.2429521Z"
      },
      {
        "title": "learn.wwl.create-question-answer-solution-ai-language.understand-question-answer-capability",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.2429541Z"
      },
      {
        "title": "learn.wwl.create-question-answer-solution-ai-language.compare-to-language-understanding",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.2429552Z"
      },
      {
        "title": "learn.wwl.create-question-answer-solution-ai-language.create-knowledge-base",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.2429559Z"
      },
      {
        "title": "learn.wwl.create-question-answer-solution-ai-language.implement-multi-turn-conversation",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.2429587Z"
      },
      {
        "title": "learn.wwl.create-question-answer-solution-ai-language.test-publish-knowledge-base",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.2429596Z"
      },
      {
        "title": "learn.wwl.create-question-answer-solution-ai-language.consume-client-interfaces",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.2429603Z"
      },
      {
        "title": "learn.wwl.create-question-answer-solution-ai-language.implement-active-learning",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.2429614Z"
      },
      {
        "title": "learn.wwl.create-question-answer-solution-ai-language.exercise-create",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.2429625Z"
      },
      {
        "title": "learn.wwl.create-question-answer-solution-ai-language.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.2429636Z"
      },
      {
        "title": "learn.wwl.create-question-answer-solution-ai-language.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.2429644Z"
      },
      {
        "title": "learn.wwl.create-question-answer-solution-ai-language",
        "type": "module",
        "completedAt": "2024-02-28T23:12:44.2429646Z"
      },
      {
        "title": "learn.wwl.build-language-understanding-model.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.5323598Z"
      },
      {
        "title": "learn.wwl.build-language-understanding-model.understand-prebuilt-capabilities",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.5323621Z"
      },
      {
        "title": "learn.wwl.build-language-understanding-model.understand-resources-for-building",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.532363Z"
      },
      {
        "title": "learn.wwl.build-language-understanding-model.define-intents-utterances-entities",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.5323639Z"
      },
      {
        "title": "learn.wwl.build-language-understanding-model.use-patterns-differentiate-similar-utterances",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.5323649Z"
      },
      {
        "title": "learn.wwl.build-language-understanding-model.use-pre-built-entity-components",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.5323661Z"
      },
      {
        "title": "learn.wwl.build-language-understanding-model.train-test-publish-review",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.5323669Z"
      },
      {
        "title": "learn.wwl.build-language-understanding-model.exercise",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.5323678Z"
      },
      {
        "title": "learn.wwl.build-language-understanding-model.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.5323701Z"
      },
      {
        "title": "learn.wwl.build-language-understanding-model.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.5323713Z"
      },
      {
        "title": "learn.wwl.build-language-understanding-model",
        "type": "module",
        "completedAt": "2024-02-28T23:12:44.5323715Z"
      },
      {
        "title": "learn.wwl.custom-text-classification.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.7857303Z"
      },
      {
        "title": "learn.wwl.custom-text-classification.understand-types-of-classification-projects",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.7857325Z"
      },
      {
        "title": "learn.wwl.custom-text-classification.understand-how-to-build-projects",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.7857334Z"
      },
      {
        "title": "learn.wwl.custom-text-classification.exercise-classify-text",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.7857343Z"
      },
      {
        "title": "learn.wwl.custom-text-classification.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.7857357Z"
      },
      {
        "title": "learn.wwl.custom-text-classification.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:44.7857373Z"
      },
      {
        "title": "learn.wwl.custom-text-classification",
        "type": "module",
        "completedAt": "2024-02-28T23:12:44.7857375Z"
      },
      {
        "title": "learn.wwl.custom-name-entity-recognition.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.0650536Z"
      },
      {
        "title": "learn.wwl.custom-name-entity-recognition.understand-custom-named",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.0650563Z"
      },
      {
        "title": "learn.wwl.custom-name-entity-recognition.tag-your-data",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.0650571Z"
      },
      {
        "title": "learn.wwl.custom-name-entity-recognition.train-evaluate-your-model",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.0650581Z"
      },
      {
        "title": "learn.wwl.custom-name-entity-recognition.exercise-extract-custom-entities",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.065059Z"
      },
      {
        "title": "learn.wwl.custom-name-entity-recognition.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.0650601Z"
      },
      {
        "title": "learn.wwl.custom-name-entity-recognition.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.0650609Z"
      },
      {
        "title": "learn.wwl.custom-name-entity-recognition",
        "type": "module",
        "completedAt": "2024-02-28T23:12:45.0650612Z"
      },
      {
        "title": "learn.wwl.translate-text-with-translator-service.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.3138159Z"
      },
      {
        "title": "learn.wwl.translate-text-with-translator-service.provision-translator-resource",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.3138185Z"
      },
      {
        "title": "learn.wwl.translate-text-with-translator-service.understand-language-detection,-translation,-transliteration",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.3138192Z"
      },
      {
        "title": "learn.wwl.translate-text-with-translator-service.specify-translation-options",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.3138203Z"
      },
      {
        "title": "learn.wwl.translate-text-with-translator-service.define-custom-translations",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.3138213Z"
      },
      {
        "title": "learn.wwl.translate-text-with-translator-service.exercise",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.3138223Z"
      },
      {
        "title": "learn.wwl.translate-text-with-translator-service.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.3138233Z"
      },
      {
        "title": "learn.wwl.translate-text-with-translator-service.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.3138242Z"
      },
      {
        "title": "learn.wwl.translate-text-with-translator-service",
        "type": "module",
        "completedAt": "2024-02-28T23:12:45.3138245Z"
      },
      {
        "title": "learn.wwl.create-speech-enabled-apps.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.5476948Z"
      },
      {
        "title": "learn.wwl.create-speech-enabled-apps.create-speech-resource",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.5476975Z"
      },
      {
        "title": "learn.wwl.create-speech-enabled-apps.speech-to-text",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.5476988Z"
      },
      {
        "title": "learn.wwl.create-speech-enabled-apps.text-to-speech",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.5477001Z"
      },
      {
        "title": "learn.wwl.create-speech-enabled-apps.audio-format-voices",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.5477015Z"
      },
      {
        "title": "learn.wwl.create-speech-enabled-apps.speech-synthesis-markup",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.5477026Z"
      },
      {
        "title": "learn.wwl.create-speech-enabled-apps.exercise-speech-app",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.547704Z"
      },
      {
        "title": "learn.wwl.create-speech-enabled-apps.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.5477053Z"
      },
      {
        "title": "learn.wwl.create-speech-enabled-apps.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.5477076Z"
      },
      {
        "title": "learn.wwl.create-speech-enabled-apps",
        "type": "module",
        "completedAt": "2024-02-28T23:12:45.547708Z"
      },
      {
        "title": "learn.wwl.translate-speech-speech-service.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.7914624Z"
      },
      {
        "title": "learn.wwl.translate-speech-speech-service.speech-service",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.7914651Z"
      },
      {
        "title": "learn.wwl.translate-speech-speech-service.translate-speech-text",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.7914659Z"
      },
      {
        "title": "learn.wwl.translate-speech-speech-service.synthesize-translation",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.7914668Z"
      },
      {
        "title": "learn.wwl.translate-speech-speech-service.exercise-translate-speech",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.7914678Z"
      },
      {
        "title": "learn.wwl.translate-speech-speech-service.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.7914691Z"
      },
      {
        "title": "learn.wwl.translate-speech-speech-service.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:45.79147Z"
      },
      {
        "title": "learn.wwl.translate-speech-speech-service",
        "type": "module",
        "completedAt": "2024-02-28T23:12:45.7914702Z"
      },
      {
        "title": "learn.wwl.create-azure-cognitive-search-solution.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.0702524Z"
      },
      {
        "title": "learn.wwl.create-azure-cognitive-search-solution.manage-capacity",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.0702557Z"
      },
      {
        "title": "learn.wwl.create-azure-cognitive-search-solution.resources-for-search",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.0702573Z"
      },
      {
        "title": "learn.wwl.create-azure-cognitive-search-solution.create-data-source",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.0702587Z"
      },
      {
        "title": "learn.wwl.create-azure-cognitive-search-solution.search-index",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.0702606Z"
      },
      {
        "title": "learn.wwl.create-azure-cognitive-search-solution.apply-filtering-sorting",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.0702622Z"
      },
      {
        "title": "learn.wwl.create-azure-cognitive-search-solution.enhance-index",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.0702636Z"
      },
      {
        "title": "learn.wwl.create-azure-cognitive-search-solution.exercise-search",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.070268Z"
      },
      {
        "title": "learn.wwl.create-azure-cognitive-search-solution.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.0702695Z"
      },
      {
        "title": "learn.wwl.create-azure-cognitive-search-solution.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.0702713Z"
      },
      {
        "title": "learn.wwl.create-azure-cognitive-search-solution",
        "type": "module",
        "completedAt": "2024-02-28T23:12:46.070272Z"
      },
      {
        "title": "learn.wwl.create-enrichment-pipeline-with-azure-cognitive-search.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.3509559Z"
      },
      {
        "title": "learn.wwl.create-enrichment-pipeline-with-azure-cognitive-search.create-custom-skill",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.3509589Z"
      },
      {
        "title": "learn.wwl.create-enrichment-pipeline-with-azure-cognitive-search.add-custom-skill",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.3509603Z"
      },
      {
        "title": "learn.wwl.create-enrichment-pipeline-with-azure-cognitive-search.exercise-custom-skill",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.3509614Z"
      },
      {
        "title": "learn.wwl.create-enrichment-pipeline-with-azure-cognitive-search.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.3509625Z"
      },
      {
        "title": "learn.wwl.create-enrichment-pipeline-with-azure-cognitive-search.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.3509637Z"
      },
      {
        "title": "learn.wwl.create-enrichment-pipeline-with-azure-cognitive-search",
        "type": "module",
        "completedAt": "2024-02-28T23:12:46.350964Z"
      },
      {
        "title": "learn.wwl.create-knowledge-store-with-azure-cognitive-search.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.5955723Z"
      },
      {
        "title": "learn.wwl.create-knowledge-store-with-azure-cognitive-search.define-projection-json",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.595575Z"
      },
      {
        "title": "learn.wwl.create-knowledge-store-with-azure-cognitive-search.define-knowledge-store",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.5955762Z"
      },
      {
        "title": "learn.wwl.create-knowledge-store-with-azure-cognitive-search.exercise-knowledge-store",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.5955771Z"
      },
      {
        "title": "learn.wwl.create-knowledge-store-with-azure-cognitive-search.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.5955782Z"
      },
      {
        "title": "learn.wwl.create-knowledge-store-with-azure-cognitive-search.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.5955791Z"
      },
      {
        "title": "learn.wwl.create-knowledge-store-with-azure-cognitive-search",
        "type": "module",
        "completedAt": "2024-02-28T23:12:46.5955794Z"
      },
      {
        "title": "learn.wwl.plan-form-recognizer-solution.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.8508531Z"
      },
      {
        "title": "learn.wwl.plan-form-recognizer-solution.understand",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.8508557Z"
      },
      {
        "title": "learn.wwl.plan-form-recognizer-solution.resources",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.8508566Z"
      },
      {
        "title": "learn.wwl.plan-form-recognizer-solution.choose-model-type",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.8508575Z"
      },
      {
        "title": "learn.wwl.plan-form-recognizer-solution.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.8508585Z"
      },
      {
        "title": "learn.wwl.plan-form-recognizer-solution.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:46.8508597Z"
      },
      {
        "title": "learn.wwl.plan-form-recognizer-solution",
        "type": "module",
        "completedAt": "2024-02-28T23:12:46.8508599Z"
      },
      {
        "title": "learn.wwl.use-prebuilt-form-recognizer-models.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.0868145Z"
      },
      {
        "title": "learn.wwl.use-prebuilt-form-recognizer-models.understand-prebuilt-models",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.0868165Z"
      },
      {
        "title": "learn.wwl.use-prebuilt-form-recognizer-models.use-general-document-read-layout-models",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.0868175Z"
      },
      {
        "title": "learn.wwl.use-prebuilt-form-recognizer-models.use-financial-id-tax-models",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.0868182Z"
      },
      {
        "title": "learn.wwl.use-prebuilt-form-recognizer-models.exercise-analyze-document-use-form-recognizer",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.0868214Z"
      },
      {
        "title": "learn.wwl.use-prebuilt-form-recognizer-models.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.0868225Z"
      },
      {
        "title": "learn.wwl.use-prebuilt-form-recognizer-models.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.0868234Z"
      },
      {
        "title": "learn.wwl.use-prebuilt-form-recognizer-models",
        "type": "module",
        "completedAt": "2024-02-28T23:12:47.0868237Z"
      },
      {
        "title": "learn.wwl.work-with-form-recognizer.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.3408984Z"
      },
      {
        "title": "learn.wwl.work-with-form-recognizer.what-form-recognizer",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.340901Z"
      },
      {
        "title": "learn.wwl.work-with-form-recognizer.get-started",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.340902Z"
      },
      {
        "title": "learn.wwl.work-with-form-recognizer.train-custom-models-with-labels",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.340903Z"
      },
      {
        "title": "learn.wwl.work-with-form-recognizer.use-models",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.3409042Z"
      },
      {
        "title": "learn.wwl.work-with-form-recognizer.form-recognizer-studio",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.3409053Z"
      },
      {
        "title": "learn.wwl.work-with-form-recognizer.exercise-extract-data-from-custom-forms",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.3409062Z"
      },
      {
        "title": "learn.wwl.work-with-form-recognizer.knowledge-check-summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.3409073Z"
      },
      {
        "title": "learn.wwl.work-with-form-recognizer.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.34091Z"
      },
      {
        "title": "learn.wwl.work-with-form-recognizer",
        "type": "module",
        "completedAt": "2024-02-28T23:12:47.3409106Z"
      },
      {
        "title": "learn.wwl.get-started-openai.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.5836081Z"
      },
      {
        "title": "learn.wwl.get-started-openai.access-azure-openai",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.5836102Z"
      },
      {
        "title": "learn.wwl.get-started-openai.use-azure-openai-studio",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.5836112Z"
      },
      {
        "title": "learn.wwl.get-started-openai.types-of-models",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.583612Z"
      },
      {
        "title": "learn.wwl.get-started-openai.deploy-models",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.5836135Z"
      },
      {
        "title": "learn.wwl.get-started-openai.explore-prompts",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.5836148Z"
      },
      {
        "title": "learn.wwl.get-started-openai.use-azure-openai-playground",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.5836157Z"
      },
      {
        "title": "learn.wwl.get-started-openai.exercise",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.5836168Z"
      },
      {
        "title": "learn.wwl.get-started-openai.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.5836178Z"
      },
      {
        "title": "learn.wwl.get-started-openai.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.5836191Z"
      },
      {
        "title": "learn.wwl.get-started-openai",
        "type": "module",
        "completedAt": "2024-02-28T23:12:47.5836193Z"
      },
      {
        "title": "learn.wwl.build-language-solution-azure-openai.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.8399229Z"
      },
      {
        "title": "learn.wwl.build-language-solution-azure-openai.integrate-azure-openai-into-app",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.8399258Z"
      },
      {
        "title": "learn.wwl.build-language-solution-azure-openai.use-openai-rest",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.8399267Z"
      },
      {
        "title": "learn.wwl.build-language-solution-azure-openai.use-openai-sdk",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.8399354Z"
      },
      {
        "title": "learn.wwl.build-language-solution-azure-openai.exercise",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.8399373Z"
      },
      {
        "title": "learn.wwl.build-language-solution-azure-openai.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.8399389Z"
      },
      {
        "title": "learn.wwl.build-language-solution-azure-openai.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:47.8399403Z"
      },
      {
        "title": "learn.wwl.build-language-solution-azure-openai",
        "type": "module",
        "completedAt": "2024-02-28T23:12:47.8399407Z"
      },
      {
        "title": "learn.wwl.apply-prompt-engineering-azure-openai.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.0874015Z"
      },
      {
        "title": "learn.wwl.apply-prompt-engineering-azure-openai.understand-prompt-engineering",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.087404Z"
      },
      {
        "title": "learn.wwl.apply-prompt-engineering-azure-openai.write-effective-prompts",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.0874049Z"
      },
      {
        "title": "learn.wwl.apply-prompt-engineering-azure-openai.provide-context-to-improve-accuracy",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.0874058Z"
      },
      {
        "title": "learn.wwl.apply-prompt-engineering-azure-openai.exercise",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.0874069Z"
      },
      {
        "title": "learn.wwl.apply-prompt-engineering-azure-openai.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.0874077Z"
      },
      {
        "title": "learn.wwl.apply-prompt-engineering-azure-openai.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.0874087Z"
      },
      {
        "title": "learn.wwl.apply-prompt-engineering-azure-openai",
        "type": "module",
        "completedAt": "2024-02-28T23:12:48.0874089Z"
      },
      {
        "title": "learn.wwl.generate-code-azure-openai.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.3474874Z"
      },
      {
        "title": "learn.wwl.generate-code-azure-openai.construct-code-natural-language",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.3474897Z"
      },
      {
        "title": "learn.wwl.generate-code-azure-openai.complete-code-assist-development",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.3474906Z"
      },
      {
        "title": "learn.wwl.generate-code-azure-openai.fix-bugs-improve-code",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.3474914Z"
      },
      {
        "title": "learn.wwl.generate-code-azure-openai.exercise",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.3474925Z"
      },
      {
        "title": "learn.wwl.generate-code-azure-openai.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.3474934Z"
      },
      {
        "title": "learn.wwl.generate-code-azure-openai.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.3474942Z"
      },
      {
        "title": "learn.wwl.generate-code-azure-openai",
        "type": "module",
        "completedAt": "2024-02-28T23:12:48.3474946Z"
      },
      {
        "title": "learn.wwl.generate-images-azure-openai.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.5832777Z"
      },
      {
        "title": "learn.wwl.generate-images-azure-openai.what-is-dall-e",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.5832798Z"
      },
      {
        "title": "learn.wwl.generate-images-azure-openai.dall-e-in-openai-studio",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.5832807Z"
      },
      {
        "title": "learn.wwl.generate-images-azure-openai.dall-e-rest-api",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.5832815Z"
      },
      {
        "title": "learn.wwl.generate-images-azure-openai.exercise-use-dall-e",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.5832824Z"
      },
      {
        "title": "learn.wwl.generate-images-azure-openai.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.5832839Z"
      },
      {
        "title": "learn.wwl.generate-images-azure-openai.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.5832847Z"
      },
      {
        "title": "learn.wwl.generate-images-azure-openai",
        "type": "module",
        "completedAt": "2024-02-28T23:12:48.583285Z"
      },
      {
        "title": "learn.wwl.use-own-data-azure-openai.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.8255616Z"
      },
      {
        "title": "learn.wwl.use-own-data-azure-openai.understand-use-own-data",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.8255636Z"
      },
      {
        "title": "learn.wwl.use-own-data-azure-openai.adding-own-data-source",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.8255644Z"
      },
      {
        "title": "learn.wwl.use-own-data-azure-openai.chat-model-own-data",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.8255652Z"
      },
      {
        "title": "learn.wwl.use-own-data-azure-openai.exercise",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.8255663Z"
      },
      {
        "title": "learn.wwl.use-own-data-azure-openai.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.8255672Z"
      },
      {
        "title": "learn.wwl.use-own-data-azure-openai.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:48.8255681Z"
      },
      {
        "title": "learn.wwl.use-own-data-azure-openai",
        "type": "module",
        "completedAt": "2024-02-28T23:12:48.8255683Z"
      },
      {
        "title": "learn.wwl.responsible-generative-ai.introduction",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:49.0636304Z"
      },
      {
        "title": "learn.wwl.responsible-generative-ai.plan-responsible-ai",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:49.0636324Z"
      },
      {
        "title": "learn.wwl.responsible-generative-ai.identify-harms",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:49.0636334Z"
      },
      {
        "title": "learn.wwl.responsible-generative-ai.measure-harms",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:49.0636353Z"
      },
      {
        "title": "learn.wwl.responsible-generative-ai.mitigate-harms",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:49.0636364Z"
      },
      {
        "title": "learn.wwl.responsible-generative-ai.operate-responsibly",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:49.0636378Z"
      },
      {
        "title": "learn.wwl.responsible-generative-ai.exercise-content-filters",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:49.0636387Z"
      },
      {
        "title": "learn.wwl.responsible-generative-ai.knowledge-check",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:49.0636397Z"
      },
      {
        "title": "learn.wwl.responsible-generative-ai.summary",
        "type": "unit",
        "completedAt": "2024-02-28T23:12:49.0636407Z"
      },
      {
        "title": "learn.wwl.responsible-generative-ai",
        "type": "module",
        "completedAt": "2024-02-28T23:12:49.063641Z"
      }
    ]
  },
  "Certifications": null,
  "VerifiableCredentials": {
    "docsId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
    "userCredentials": []
  },
  "SkillAssessment": null,
  "Assessments": null,
  "NextSteps": null,
  "Challenges": {
    "Table": [
      {
        "ProfileID": 11899904,
        "CreatedDate": "2024-03-05T20:17:09.0496888",
        "LastUpdatedDate": "2024-03-05T20:17:09.0496888",
        "FirstName": "",
        "LastName": "",
        "Email": "",
        "CompanyName": null,
        "CountryName": null,
        "LearnUserName": "",
        "LearnUserID": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "PDCId": null
      }
    ]
  },
  "Lists": {
    "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
    "lists": [
      {
        "id": "w2dwf7mgp614o3",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "name": "Copied Favorites",
        "description": "",
        "type": "collection",
        "lastModified": "2024-03-05T20:17:09+00:00",
        "totalItems": 0,
        "items": [],
        "itemCount": 0,
        "sections": [],
        "sectionCount": 0,
        "isPrivate": false,
        "isOfficial": false,
        "shouldLocalize": false,
        "isLocalized": false,
        "isFallbackLocale": false,
        "showUserDisplayName": false,
        "moduleCount": 0,
        "completedModuleCount": 0,
        "remainingDuration": 0,
        "totalDuration": 0
      },
      {
        "id": "bookmarks",
        "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
        "name": "Bookmarks",
        "description": "",
        "type": "bookmarks",
        "lastModified": "2024-03-05T20:17:07+00:00",
        "totalItems": 0,
        "items": [],
        "itemCount": 0,
        "sections": [],
        "sectionCount": 0,
        "isPrivate": false,
        "isOfficial": false,
        "shouldLocalize": false,
        "isLocalized": false,
        "isFallbackLocale": false,
        "showUserDisplayName": false,
        "moduleCount": 0,
        "completedModuleCount": 0,
        "remainingDuration": 0,
        "totalDuration": 0
      }
    ],
    "createdSkillingPlans": {
      "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
      "skillingPlanFilter": 1,
      "skillingPlans": [],
      "count": 0
    },
    "createdLearnChallenges": {
      "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
      "learnChallengeFilter": 0,
      "challenges": [],
      "count": 0
    }
  },
  "TechProfile": {
    "email": "Jacob.Zwickler@ibm.com",
    "locale": "en-us",
    "country": "US",
    "contactPointTopicSetting": "OptInExplicit",
    "isInstructor": false,
    "isChallengeAdmin": false,
    "isQnaModerator": false,
    "source": "docs",
    "authenticationModes": [
      {
        "id": "fdf17455-8a5d-4325-8788-a16fb9c29aa9",
        "type": "AAD",
        "tenantId": "fcf67057-50c9-4ad4-98f3-ffca64add9e9",
        "upn": "Jacob.Zwickler@ibm.com",
        "oid": "fdf17455-8a5d-4325-8788-a16fb9c29aa9",
        "dateAcceptedPrivacyNotice": "2024-03-05T20:16:14.4683743+00:00",
        "dateAdded": "2024-03-05T20:16:14.4683744+00:00"
      },
      {
        "id": "00030000B5EFA447",
        "type": "MSA",
        "tenantId": "9188040d-6c67-4c5b-b112-36a304b66dad",
        "upn": "jazwickler@gmail.com",
        "oid": "00000000-0000-0000-96e0-aa99d4a5fc41",
        "dateAcceptedPrivacyNotice": "2024-02-28T23:12:28.6680314+00:00",
        "dateAdded": "2024-02-28T23:12:28.6680315+00:00"
      }
    ],
    "groups": [],
    "transcriptSettings": {
      "publicLink": {
        "showModules": true,
        "showLegalName": true,
        "showMCID": true,
        "showContactEmail": true
      },
      "print": {
        "showModules": true,
        "showLegalName": true,
        "showMCID": true,
        "showContactEmail": true
      }
    },
    "certificationSettings": {
      "print": {
        "showLegalName": true,
        "showMCID": true,
        "showContactEmail": true
      }
    },
    "qnaEmailPreferences": {
      "allEmail": true,
      "autoFollowAsked": true,
      "autoFollowAnswered": true,
      "autoFollowCommented": true,
      "autoFollowTagged": false,
      "emailEventSettings": {
        "newMention": "instant",
        "newModeration": "instant",
        "answerPosted": "instant",
        "answerAccepted": "instant",
        "commentPosted": "instant",
        "newPrivateMessage": "instant"
      }
    },
    "sharingId": "D59FA4AE99C10F2D",
    "userId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
    "userName": "JakeZwickler-4354",
    "displayName": "Jake Zwickler",
    "isPrivate": false,
    "affiliations": [],
    "followerCount": 0,
    "followingCount": 0,
    "answersAccepted": 0,
    "reputationPoints": 0,
    "createdOn": "3/5/2024 8:16:14 PM"
  },
  "Q&A": {
    "docsId": "8315652a-f557-4d4b-a738-7e4a3eabdeff",
    "questions": [],
    "answers": [],
    "comments": []
  }
}
